module.exports = __webpack_public_path__ + "fonts/nunito-sans-v6-latin-800.1258be07.ttf";